/**
 * Values are injected at build time by Vite (`vite.config.ts` → `define`).
 * Use this to confirm a fresh upload reached GCS/CDN (version + commit + time).
 */
export interface BuildInfo {
  version: string;
  builtAt: string;
  commit: string;
}

function parseEmbeddedBuildInfo(): BuildInfo {
  const raw = __DWIK_BUILD__ as unknown as string | BuildInfo;
  if (typeof raw === "string") return JSON.parse(raw) as BuildInfo;
  return raw as BuildInfo;
}

export const buildInfo: BuildInfo = parseEmbeddedBuildInfo();
